import { NgModule } from "@angular/core";
import { FaIconLibrary } from "@fortawesome/angular-fontawesome";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { fad } from "@fortawesome/pro-duotone-svg-icons";
import { fal } from "@fortawesome/pro-light-svg-icons";
import { far } from "@fortawesome/pro-regular-svg-icons";
import { fas } from "@fortawesome/pro-solid-svg-icons";
import { AuthNetPaymentComponent } from "../components/auth-net-payment/auth-net-payment.component";
import { DatacapPaymentComponent } from "../components/datacap-payment/datacap-payment.component";
import { FocuspayPaymentComponent } from "../components/focuspay-payment/focuspay-payment.component";
import { I4goPaymentComponent } from "../components/i4go-payment/i4go-payment.component";
import { StoredCreditCardComponent } from "../components/stored-credit-card/stored-credit-card.component";
import { SharedModule } from "./shared.module";

@NgModule({
	declarations: [AuthNetPaymentComponent, DatacapPaymentComponent, I4goPaymentComponent, FocuspayPaymentComponent, StoredCreditCardComponent],
	exports: [AuthNetPaymentComponent, DatacapPaymentComponent, I4goPaymentComponent, FocuspayPaymentComponent, StoredCreditCardComponent],
	imports: [SharedModule],
})
export class PaymentsModule {
	constructor(library: FaIconLibrary) {
		library.addIconPacks(fas, far, fal, fab, fad);
	}
}
